import { createApi } from "./api";

class AuthService {
  constructor() {
    this.api = createApi("/auth");
  }

  verify(token) {
    return this.api.get("/verify", {
      headers: { Authorization: `Bearer ${token}` },
      // Restauración de sesión al cargar: no mostrar toast si falla
      silent: true,
    });
  }

  signup(userData) {
    return this.api.post("/signup", userData);
  }

  login(userData) {
    return this.api.post("/login", userData);
  }

  refresh(refreshToken) {
    return this.api.post("/refresh", { refreshToken }, { silent: true });
  }
}

const authService = new AuthService();

export default authService;
